import React, { useContext } from "react";
import google from "../../../../../images/LandingPageImage/google.png";
import Ornament from "../../../../../images/LandingPageImage/Ornament.svg"
import Navbar from '../../common/Navbar';
import FAQContactSection from "../FAQContactSection";
import CallToAction from '../CallToAction';
import tracking from "../../../../../images/LandingPageImage/tracking.png";
import { Link } from "react-router-dom";
import MyContext from "../../../../../MyContext";
import Footer from '../../common/Footer';


export default function AudienceTargeting() {
  
  const { openFreeTrialModal } = useContext(MyContext);

  return (
    <div>
      <div className='hero-bg pt-4 pt-md-5 overflow-hidden font-inter' style={{ minHeight: '90vh' }}>
        <Navbar />

        <div className="container mt-4 mt-lg-5 mb-5">
          <div className="row align-items-center justify-content-center">


            <div className="col-12 col-lg-6 px-3 px-md-4 order-2 order-lg-1 text-center text-lg-start mt-4 mt-lg-0">

              <h1 className="display-6 display-md-5 fw-semibold font-bricolage mb-3 mb-md-4 lh-sm text-white">
                Audience Targeting: Reach the <br className="d-none d-md-block" />
                Right Customers on <br className="d-none d-md-block" />
                <span style={{ color: 'yellowgreen' }}>WhatsApp</span>
              </h1>

              <p className="small text-light opacity-90 mb-4 fw-light mx-auto mx-lg-0" style={{ maxWidth: '550px', lineHeight: '1.6' }}>
                In today’s digital-first world, success is no longer about reaching everyone, it's about reaching the right people. Smart audience segmentation helps businesses deliver relevant, personalized messages to specific customer groups, leading to higher engagement and improved ROI.
              </p>


           <div className="d-flex flex-column flex-sm-row justify-content-center justify-content-lg-start gap-3 mt-4">
                <Link to="/login" className="text-decoration-none">
                  <button
                    type="button"
                    className="btn btn-outline-google rounded-pill fw-semibold d-flex align-items-center justify-content-center gap-2 px-4 py-2"
                    style={{ minHeight: "48px" }}
                  >
                    <span
                      className="rounded-circle bg-white d-flex align-items-center justify-content-center"
                      style={{ width: "28px", height: "28px" }}
                    >
                      <img
                        src={google}
                        alt="Google"
                        style={{ width: "16px" }}
                      />
                    </span>
                    <span className="text-nowrap">Start With Google</span>
                  </button>
                </Link>

                <button
                  onClick={openFreeTrialModal}
                  className="btn btn-outline-demo rounded-pill px-4 py-2 fw-semibold d-flex align-items-center justify-content-center"
                  style={{ minHeight: "48px" }}
                >
                  Book a Demo
                </button>
              </div>
            </div>


            <div className="col-12 col-lg-6 mb-5 mb-lg-0 order-2 order-lg-2">
              <div className="position-relative d-flex align-items-center justify-content-center p-2 p-md-3">


                <img
                  src={Ornament}
                  className="img-fluid floating-animation"
                  alt="Background"
                  style={{ opacity: '0.4', filter: 'blur(15px)', width: '80%' }}
                />


                <img
                  src={tracking}
                  alt="audience_targeting"
                  className="position-absolute img-fluid main-image-hover"
                  style={{
                    maxWidth: '85%',
                    height: 'auto',
                    zIndex: 2,
                    filter: 'drop-shadow(0px 10px 20px rgba(0,0,0,0.3))'
                  }}
                />
              </div>
            </div>

          </div>
        </div>

        <style>{`
  @media (max-width: 767.98px) {
    .display-6 {
      font-size: 1.85rem !important;
    }
  }

  .main-image-hover {
    transition: transform 0.5s ease;
  }

  .main-image-hover:hover {
    transform: scale(1.03) translateY(-5px);
  }

  @keyframes float {
    0%, 100% { transform: translateY(0px); }
    50% { transform: translateY(-15px); }
  }

  .floating-animation {
    animation: float 6s ease-in-out infinite;
  }
`}</style>

      </div>
      <section className="min-vh-100 d-flex who-bg align-items-center font-inter py-5 px-3">

        <div className="container mx-auto text-center" style={{ maxWidth: '1050px' }}>

          <h2 className="fs-2 fw-semibold font-bricolage text-white mb-4">
            What Is Audience Targeting on WhatsApp?
          </h2>

          <div className="mb-5 px-md-5 mx-auto" style={{ maxWidth: '900px' }}>
            <p className="fs-6 opacity-90 mb-4 fw-light lh-lg text-yellowgreen">
              Audience targeting is the process of grouping customers based on factors such as demographics, behavior, purchase history, interests, and engagement levels. Instead of sending the same message to everyone.
            </p>
          </div>


          <div className="row g-2 g-lg-3 justify-content-center mt-2">


            <div className="col-12 col-md-6 col-lg-6">
              <div className="glass-card h-100 p-3 p-md-4 rounded-4 text-start border border-light border-opacity-10 shadow-lg transition-all hover-effect"
                style={{ background: 'linear-gradient(to left, rgba(34, 125, 83, 0), rgba(34, 125, 83, 0.87))' }}>
                <h3 className="h5 fw-bold mb-3 text-yellowgreen font-bricolage">
                  Why Audience Targeting Matters for Businesses
                </h3>
                <p className="text-white opacity-75 fw-light lh-base">
                  SendBulkMsg helps businesses plan and scale WhatsApp communication with ease. From official WhatsApp API integration to bulk messaging, automation, and performance insights, the platform ensures secure, compliant communication with consistently high delivery rates.
                </p>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-6">
              <div className="glass-card h-100 p-3 p-md-4 rounded-4 text-start border border-light border-opacity-10 shadow-lg transition-all hover-effect"
                style={{ background: 'linear-gradient(to left, rgba(34, 125, 83, 0), rgba(34, 125, 83, 0.87))' }}>
                <h3 className="h5 fw-bold mb-3 text-yellowgreen font-bricolage">
                  How SendBulkMsg Enables Advanced Audience Targeting
                </h3>
                <p className="text-white opacity-75 fw-light lh-base">
                  SendBulkMsg’s WhatsApp marketing software allows businesses to identify, segment, and engage audiences with precision. With smart filters, automated message flows, and real-time analytics, brands can run data-driven campaigns that feel personal while operating at scale.
                </p>
              </div>
            </div>

          </div>
        </div>


      </section>


      <section className="min-vh-100 d-flex who-bg align-items-center font-inter py-5 px-3">

        <div className="container mx-auto text-center" style={{ maxWidth: '1150px' }}>

          <h2 className="fs-2 fw-bold font-bricolage text-white mb-4">
            Audience Targeting Across Industries
          </h2>


          <div className="mb-5 px-md-5 mx-auto" style={{ maxWidth: '900px' }}>
            <p className="fs-6 opacity-90 mb-4 fw-light lh-lg text-yellowgreen">
              Audience targeting works for businesses of every size and sector. With SendBulkMsg, campaigns can be customized based on industry-specific needs and customer behavior.
            </p>
          </div>


          <div className="row g-4 justify-content-center mt-2">
            <div className="col-12 col-md-3">
              <div className="glass-card h-100 p-4 p-md-4 rounded-4 text-start border border-light border-opacity-10 shadow-lg transition-all hover-effect"
                style={{ background: 'linear-gradient(to left, rgba(34, 125, 83, 0), rgba(34, 125, 83, 0.87))' }}>
                <h3 className="h6 fw-bold mb-3 text-yellowgreen font-bricolage">Industry-Focused Audience Segmentation</h3>
                <p className="text-white opacity-75 fw-light small lh-base">
                  WhatsApp marketing enables businesses to segment users by intent and activity. E-commerce brands can target repeat buyers, while sectors like education, real estate, and finance can reach users with messages aligned to their requirements.
                </p>
              </div>
            </div>


            <div className="col-12 col-md-3">
              <div className="glass-card h-100 p-4 p-md-4 rounded-4 text-start border border-light border-opacity-10 shadow-lg transition-all hover-effect"
                style={{ background: 'linear-gradient(to left, rgba(34, 125, 83, 0), rgba(34, 125, 83, 0.87))' }}>
                <h3 className="h6 fw-bold mb-3 text-yellowgreen font-bricolage">Personalized and Meaningful Communication</h3>
                <p className="text-white opacity-75 fw-light small lh-base">
                  Effective targeting is rooted in relevance. Addressing customers by name or preferences helps businesses create conversations that feel natural, build trust, and increase engagement—without overwhelming users.
                </p>
              </div>
            </div>


            <div className="col-12 col-md-3">
              <div className="glass-card h-100 p-4 p-md-4 rounded-4 text-start border border-light border-opacity-10 shadow-lg transition-all hover-effect"
                style={{ background: 'linear-gradient(to left, rgba(34, 125, 83, 0), rgba(34, 125, 83, 0.87))' }}>
                <h3 className="h6 fw-bold mb-3 text-yellowgreen font-bricolage">Best Practices for Smarter Targeting</h3>
                <p className="text-white opacity-75 fw-light small lh-base">
                  Successful outreach depends on opt-in messaging and controlled frequency. Following WhatsApp policies ensures better delivery rates, higher responses, and long-term compliance with the platform.
                </p>
              </div>
            </div>


            <div className="col-12 col-md-3">
              <div className="glass-card h-100 p-4 p-md-4 rounded-4 text-start border border-light border-opacity-10 shadow-lg transition-all hover-effect"
                style={{ background: 'linear-gradient(to left, rgba(34, 125, 83, 0), rgba(34, 125, 83, 0.87))' }}>
                <h3 className="h6 fw-bold mb-3 text-yellowgreen font-bricolage">Real-Time Audience Insights & Optimization</h3>
                <p className="text-white opacity-75 fw-light small lh-base">
                  Track audience performance in real time to understand what works best, refine targeting strategies, and continuously improve campaign effectiveness for higher engagement and better ROI.
                </p>
              </div>
            </div>

          </div>
        </div>


      </section>
   

      <FAQContactSection />
      <CallToAction />
      <Footer/>
    </div>
  )
}


